import React, { useState, useEffect, useContext } from "react";
import { Popover, List, MenuItem } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import _ from "lodash";
import { UserContext } from "../../context/UserContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useStyles } from "../filters/Filters.styles";
import {usePopperStyles} from "./Popper.styles";
import JobUtils from "../../utils/JobsUtils";
import ConfigUtils from "../../utils/ConfigUtils";
import StatusUtils from "../../utils/StatusUtils";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import 'moment-timezone';
import useStateRef from "../../hooks/useStateRef";
import { UserRoles } from "../../constants/UserRoles";

// TO DO -  Need to look into the way of passing it as object
const AppPopoverButton = ({ mode, selectedToolActon, handleSelection, job, handleMenu, selectAll, handleModel, request }) => {
  const statuses = ConfigUtils.getStatuses();
  const statusChangeRules = ConfigUtils.getStatusChangeRules();
  const classes = usePopperStyles();
  const classStyle = useStyles();
  const [type, setType] = useState(null);
  const { userRole } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [value, setValue] = useStateRef("");

  const jobData = _.size(job) > 1 ? null : _.first(job);

  const { assignedTo } = useContext(UserContext);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  
  const handleSearch = (e, column) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else return items.filter((x) => _.toLower(_.get(x, column)).includes(_.toLower(target.value)));
      },
    });
  };

  useEffect(() => {
    if (selectedToolActon.action !== null) {
      setType(selectedToolActon.action);
      setAnchorEl(selectedToolActon.event);
      setValue(_.get(selectedToolActon, "selected.props.children", _.get(selectedToolActon, "selected", "")));
    }
    if (mode === "summary") {
      if (_.get(selectedToolActon, "icon") === "status") {
        setValue(_.get(jobData, "status", ""));
      }
      if (_.get(selectedToolActon, "icon") === "reassign-active") {
        setValue(_.get(jobData, "assignedTo.fullName", ""));
      }
      if (_.get(selectedToolActon, "icon") === "calendar") {
        setValue(_.get(jobData, "dueDate", ""))
      }
    }
    // eslint-disable-next-line
  }, [selectedToolActon,jobData,mode]);

  const isStatusChangeConditionMet = (changeRule, jobValue) => {
    let cond = _.get(changeRule, "condition");
    if (!cond) {
      return true;
    }
    let prop = _.get(jobValue, _.get(cond, "prop"));
    let regEx = new RegExp(cond.regex);
    return regEx.test(prop);
  };
  const handleClose = (typeValue, data, isSelected = false) => {
    if (_.size(job) === 1 && typeValue === "statusChange" && !selectAll) {
      let currentStatus = _.get(jobData, "status");
      let to = _.get(statusChangeRules, _.get(data, "value") + ".to", "");
      let from = _.get(statusChangeRules, currentStatus + ".from", "");
      let isToConditionMet = isStatusChangeConditionMet(to, jobData);
      if (_.get(data, "value") === "COMPLETE" && _.get(jobData, "qcRequired", false) && !_.get(jobData, "processor.transcodeQualityCheck.qcDone")) {
        handleModel(currentStatus, {
          modalType: "Ok",
          title: "QC Required",
          message: "QC is required for this job before marking it complete",
        });
      } else if (_.get(to, "confirm") && isToConditionMet) {
        handleMenu(to, typeValue, data);
      } else if (_.get(from, "confirm")) {
        handleMenu(from, typeValue, data);
      } else if (_.get(data, "value") === "WF_QC_IN_PROGRESS") {
        handleSelection("QC", _.get(data, "value"));
      } else if (_.get(data, "value") === "WF_QC_DONE") {
        handleSelection("QC", _.get(data, "value"));
      } else {
        handleSelection(typeValue, data);
      }
    } else {
      handleSelection(typeValue, data, isSelected);
    }
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const searchField = (typeValue, options, key) => {
    return (
      <>
        <input
          type="search"
          style={{
            border: "none",
            borderBottom: "1px solid #718DA8",
            padding: "0px 5px",
            margin: "10px 10px 0px 10px",
            outline: "none",
            height: "36px",
          }}
          onChange={(e) => {
            handleSearch(e, key);
          }}
        />
        <div key={"div_list_app" + typeValue} className={classes.list}>
          <List key={"list_app" + typeValue}>
            {_.isEmpty(filterFn.fn(options)) ? (
              <div style={{ padding: "15px" }}>
                {_.isEmpty(options) ? (
                  <span>
                    {" "}
                    Loading <CircularProgress size={20} />{" "}
                  </span>
                ) : (
                  "No options found"
                )}
              </div>
            ) : (
              _.map(filterFn.fn(options), (status, index) => {
                const isSelected = _.trim(value) === _.get(status, key) || value === _.get(status, "value", null);
                return (
                  <MenuItem
                    style={{ padding: "15px" }}
                    className={classStyle.dropdown}
                    selected={isSelected}
                    value={_.get(status, key)}
                    onClick={(_event) => handleClose(typeValue, status, isSelected)}
                    key={typeValue + status + index}
                    button>
                    <span>{_.get(status, key)}</span>
                    {isSelected && <span style={{ marginLeft: '10px' }}><CheckIcon /></span>}
                  </MenuItem>
                );
              })
            )}
          </List>
        </div>
      </>
    );
  };
  const getStatus = () => {
    const role = "ops";

    let statusList = _.find(statuses, (item) => {
      return role === _.get(item, "role");
    });
    let currentStatus = _.get(jobData, "status", "");

    statusList = _.reject(statusList.statuses, (item) => {
      return /(^(DRAFT|WF_SOURCE_MISSING|WF_PROCESSING|WF_DONE|WF_PARTIAL|WF_PENDING|WF_DELIVERING|WF_SOURCING|WF_ERROR|WF_VIP_ERROR|WF_VIP_INITIATED|WF_VIP_PROCESSING|WF_VIP_VIDEO_ARRIVED|WF_VIP_MMRK)$)/.test(
        item.value
      );
    });
    if (userRole === "requestor") {
      if (currentStatus === "SUBMITTED") {
        return _.reject(statusList, (item) => {
          return item.value !== "ON_HOLD";
        });
      } else {
        return _.reject(statusList, (item) => {
          return item.value !== "SUBMITTED";
        });
      }
    }
    if (!_.has(jobData, "steamId")) {
      statusList = _.reject(statusList, (item) => item.value === "INITIATE_STEAM");
    }
    if (mode === "dashboard" || mode === "requestSummary") {
      statusList = _.reject(statusList, (item) => {
        return /(^(INITIATE_WORKFLOW|WF_VIP|INITIATE_STEAM)$)/.test(item.value);
      });
    }
    if (!/^WF_QC_PENDING$/.test(currentStatus)) {
      statusList = _.reject(statusList, (item) => {
        return /^WF_QC_IN_PROGRESS$/.test(item.value);
      });
    }

    if (!/^WF_QC_DONE$/.test(currentStatus)) {
      statusList = _.reject(statusList, (item) => {
        return /^RESUME_WORKFLOW$/.test(item.value);
      });
    }

    if (_.size(job) === 1 && !selectAll) {
      //TO DO-Comment out for now need to take care later
      if (currentStatus === "PROCESSING" || (currentStatus === "PAC_READY" && _.get(jobData, "jobType") === "EVENT_SCREENERS")) {
        statusList = _.get(jobData, "qcRequired", false) ? statusList : _.reject(statusList, (item) => /^(WF_QC_PENDING)$/.test(item.value));
      } else {
        statusList = _.reject(statusList, (item) => {
          return /^(WF_QC_PENDING)$/.test(item.value);
        });
      }

      if (/^(WF_QC_PENDING)$/.test(currentStatus)) {
        return _.filter(statusList, (item) => {
          return /^(WF_QC_IN_PROGRESS|CANCELLED)$/.test(item.value);
        });
      }
      if (/^(WF_QC_IN_PROGRESS)$/.test(currentStatus)) {
        statusList.push({
          value: "WF_QC_IN_PROGRESS",
          label: "QC in Progress",
        });
        return _.filter(statusList, (item) => {
          return /^(CANCELLED|WF_QC_DONE|WF_QC_IN_PROGRESS)$/.test(item.value);
        });
      }

      if (!/^(WF_QC_IN_PROGRESS|WF_QC_DONE)$/.test(currentStatus)) {
        return _.reject(statusList, (item) => {
          return /^(WF_QC_DONE)$/.test(item.value);
        });
      }

      //TO DO- need to check this status condition
      if (/^(WF_QC_DONE)$/.test(currentStatus)) {
        if (JobUtils.isQCPendingAutomated(jobData)) {
          return _.filter(statusList, (item) => {
            return /^(CANCELLED|RESUME_WORKFLOW)$/.test(item.value);
          });
        } else if (!_.isEmpty(_.get(jobData, "auditTrail"))) {
          return _.reject(statusList, (item) => {
            return /^(DRAFT|RESUME_WORKFLOW|ON_HOLD)$/.test(item.value);
          });
        } else {
          return _.reject(statusList, (item) => {
            return /^(DRAFT|ON_HOLD)$/.test(item.value);
          });
        }
      }

      if (_.get(jobData, "qcRequired", false) && /^(PROCESSING)$/.test(currentStatus)) {
        return _.reject(statusList, (item) => {
          return /^(COMPLETE)$/.test(item.value);
        });
      }
      
    }
    //Group menu option
    if ((_.size(job) > 1 && _.isArray(job)) || selectAll) {
      statusList = _.reject(statusList, (item) => {
        return /^(WF_QC_PENDING|INITIATE_WORKFLOW)$/.test(item.value);
      });

      // TO DO- Need to check
      if (StatusUtils.containsWorkFlowAndNonWorkFlowStatuses(_.get(request, "jobs"))) {
        statusList = _.filter(statusList, (item) => {
          return /(^(TECH_HOLD|CANCELLED)$)/.test(item.value);
        });
      }

      if (userRole === UserRoles.ADMIN || userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN) {
        return _.reject(statusList, (item) => {
          return /(^(ON_HOLD|DRAFT|COMPLETE)$)/.test(item.value);
        });
      } else if (userRole === "ops") {
        return _.reject(statusList, (item) => {
          return /(^(CANCELLED|ON_HOLD|DRAFT)$)/.test(item.value);
        });
      } else {
        return _.reject(statusList, (item) => {
          return /(^(CANCELLED|ON_HOLD|DRAFT|COMPLETE)$)/.test(item.value);
        });
      }
    }
    //TO DO-Check & remove after confirmation
    else if (StatusUtils.checkForWorkFlowStatus(currentStatus) && !StatusUtils.isWorkflowError(currentStatus)) {
      return _.filter(statusList, (item) => {
        return _.has(jobData, "steamId") ? /(^(CANCELLED)$)/.test(item.value) : /(^(TECH_HOLD|CANCELLED)$)/.test(item.value);
      });
    } else if (userRole === UserRoles.ADMIN || userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN) {
      return _.reject(statusList, (item) => {
        return /(^(ON_HOLD|DRAFT)$)/.test(item.value);
      });
    } else if (userRole === "ops") {
      return _.reject(statusList, (item) => {
        return /(^(CANCELLED|ON_HOLD|DRAFT)$)/.test(item.value);
      });
    } else {
      return _.reject(statusList, { value: "DRAFT", label: "Draft" });
    }
  };

  const renderActionType = (typeValue) => {
    switch (typeValue) {
      case "statusChange":
        return searchField(typeValue, getStatus(), "label");
      case "assignTo":
        return searchField(typeValue, assignedTo, "fullName");
      case 'dueDate':
        return (<DatePicker selected={_.isEmpty(value) ? null : new Date(value)} calendarClassName={classes.calendar} inline onChange={(value1) => {
          let dueDate = Moment(_.isNil(value1) ? new Date() : value1).tz("America/New_York").format("YYYY-MM-DDTHH:mm:ssZ");
          handleClose(typeValue, dueDate);
        }} minDate={new Date()} />)
      default:
        return null;
    }
  };

  return (
    <div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        classes={{ paper: classes.root }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        {renderActionType(type)}
      </Popover>
    </div>
  );
};
AppPopoverButton.defaultProps = {
  selectedToolActon: null,
  handleSelection: null,
  job: null,
  handleMenu: null,
  selectAll: false,
  handleModel: null,
};

export default AppPopoverButton;
